import { supabase } from '../supabase';

/**
 * Upload dokumenta i upis u bazu podataka - AŽURIRANO SA NOVIM POLJIMA
 */
export const uploadDocumento = async ({ 
  file, 
  idUtente, 
  idAzienda, 
  tipologia, 
  anno, 
  mese,
  nome_corso,   // NOVO
  valido_dal,   // NOVO
  valido_al,    // NOVO
  note          // NOVO
}) => {
  try {
    // 1. Generiši čistu putanju fajla
    const fileExt = file.name.split('.').pop();
    const fileName = `${Math.random().toString(36).substring(2)}_${Date.now()}.${fileExt}`;
    const filePath = `${idAzienda}/${idUtente}/${tipologia}/${fileName}`;

    // 2. Upload u Supabase Storage
    const { data: storageData, error: storageError } = await supabase.storage
      .from('aziende')
      .upload(filePath, file);

    if (storageError) throw storageError;

    // 3. Upis metapodataka u tabelu 'documenti'
    const { data, error: dbError } = await supabase
      .from('documenti')
      .insert([
        {
          nome_file: file.name,
          url_path: filePath,
          tipologia: tipologia,
          anno: anno ? parseInt(anno) : null,
          mese: mese || null,
          dimensione_file: file.size,
          id_utente: idUtente,
          id_azienda: idAzienda,
          // DODATA NOVA POLJA ISPOD:
          nome_corso: nome_corso || null,
          valido_dal: valido_dal || null,
          valido_al: valido_al || null,
          note: note || null
        }
      ])
      .select();

    if (dbError) {
      // Ako upis u bazu ne uspije, obriši fajl iz storage-a
      await supabase.storage.from('aziende').remove([filePath]);
      throw dbError;
    }

    return { success: true, data };
  } catch (err) {
    console.error("Greška pri uploadu:", err.message);
    throw err;
  }
};

export const hardDeleteDocument = async (docId, filePath) => {
  try {
    // 1. Obriši fizički fajl iz Storage-a
    const { error: storageError } = await supabase.storage
      .from('aziende')
      .remove([filePath]);
    if (storageError) throw storageError;

    // 2. Obriši red iz baze podataka
    const { error: dbError } = await supabase
      .from('documenti')
      .delete()
      .eq('id', docId);
    if (dbError) throw dbError;

    return { success: true };
  } catch (err) {
    console.error("Hard Delete Error:", err.message);
    throw err;
  }
};

/**
 * Vraćanje dokumenta iz kante (Restore)
 */
export const restoreDocument = async (docId) => {
  const { data, error } = await supabase
    .from('documenti')
    .update({ 
      is_deleted: false, 
      deleted_at: null,
      deleted_by: null 
    })
    .eq('id', docId);
  
  if (error) throw error;
  return data;
};


/**
 * Poseban upload za Badge (QR Code)
 */
export const uploadBadge = async ({ fileBlob, idUtente, idAzienda }) => {
  try {
    const filePath = `${idAzienda}/${idUtente}/badge/qrcode.png`;

    // Upload u 'aziende' bucket
    const { data, error } = await supabase.storage
      .from('aziende')
      .upload(filePath, fileBlob, {
        contentType: 'image/png',
        upsert: true // Ako postoji, neka ga pregazi novim
      });

    if (error) throw error;
    return { success: true, path: filePath };
  } catch (err) {
    console.error("Errore upload badge:", err.message);
    throw err;
  }
};